import { useAuth } from "@sal/authentication.react";
import { usePageTabTitle, usePortalApplicationContext } from "@sal/onevent-portal";
import { useNavigate } from "react-router-dom";
import { PageLayout } from "../components/PageLayout";

export function LogoutPage() {
	const auth = useAuth();
	const navigate = useNavigate();
	const { organisations, impersonation } = usePortalApplicationContext();
	usePageTabTitle({ title: "Logout" });

	const loginPath = auth.authenticationMethod === "SalCore" ? "/LoginSalCore" : "/Login";

	auth.logout(() => {
		organisations.clearOrganisations();
		impersonation.shutdown();
		navigate(loginPath);
	});

	return (
		<PageLayout title={"Logout"}>
			<div>Logging out...</div>
		</PageLayout>
	);
}